/* ══════════════════════════════════════════════════════════════════════
   PUBLISHING INSIGHTS — vanilla port of the handoff's DCLogic class.
   Same behaviour, no framework.  Everything is scoped to .tws-blog so the
   locked chrome and footer are never touched.

   The handoff's scroll-progress rail lived inside its own header, which
   this page drops in favour of the locked nav — so _initRail() is gone
   with it.  Only the reveal / word-split / rule logic is ported.

   __twsBlogInit is a run-once guard: on Shopify this script is emitted
   once PER SECTION, so without it the reveals bind several times over.
   ══════════════════════════════════════════════════════════════════════ */
(function(){
  if (window.__twsBlogInit) return;
  window.__twsBlogInit = true;

  var PAGE_SIZE = 6;
  var roots = [], state = { cat: 'All', query: '', shown: PAGE_SIZE };

  /* ⚠ Locally the whole page sits in ONE .tws-blog wrapper, but on Shopify every
     section emits its own — so a single querySelector('.tws-blog') binds to the
     hero alone and never sees a post, a chip or the counters.  Every lookup goes
     through these helpers, which span all wrappers and so behave identically in
     both places.  They stay scoped to .tws-blog, never the whole document, so
     the locked chrome and footer are still untouched. */
  function qsa(sel){
    var out = [];
    roots.forEach(function(r){
      out = out.concat(Array.prototype.slice.call(r.querySelectorAll(sel)));
    });
    return out;
  }
  function qs(sel){
    for (var i = 0; i < roots.length; i++){
      var el = roots[i].querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  /* ---- filter / search / load more ---- */
  function apply(){
    var cards = qsa('.post');
    var q = state.query.trim().toLowerCase();
    var matched = 0;
    cards.forEach(function(c){
      var tags = (c.getAttribute('data-cat') || '').split('|').map(function(t){ return t.trim(); });
      var text = (c.textContent || '').toLowerCase();
      /* tws-blog-search.js owns matching so the panel and the filtered page
         can never disagree.  The fallback keeps this file working on its own
         if that asset is ever absent. */
      var ok = (state.cat === 'All' || tags.indexOf(state.cat) !== -1) &&
               (!q || (typeof window.__tsxMatch === 'function'
                         ? window.__tsxMatch(c, state.query)
                         : text.indexOf(q) !== -1));
      if (!ok){ c.hidden = true; c.classList.remove('pend'); return; }
      matched += 1;
      c.hidden = false;
      c.classList.toggle('pend', matched > state.shown);
    });

    qsa('.chip').forEach(function(b){
      var on = b.getAttribute('data-filter') === state.cat;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var visible = Math.min(matched, state.shown);
    var cl = qs('#countLabel');
    if (cl) cl.textContent = matched + (matched === 1 ? ' article' : ' articles');
    var pl = qs('#pageLabel');
    if (pl) pl.textContent = matched ? 'Showing ' + visible + ' of ' + matched : '';
    var more = qs('#loadMore');
    if (more) more.style.display = matched > state.shown ? '' : 'none';
    var wrap = qs('#moreWrap');
    if (wrap) wrap.style.display = matched ? '' : 'none';
    var note = qs('#emptyNote');
    if (note) note.classList.toggle('on', matched === 0);
  }

  function initControls(){
    var bar = qs('#chipbar');
    if (bar) bar.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.chip');
      if (!b) return;
      state.cat = b.getAttribute('data-filter');
      state.shown = PAGE_SIZE;
      apply();
    });

    var q = qs('#q');
    if (q) q.addEventListener('input', function(e){
      state.query = e.target.value;
      state.shown = PAGE_SIZE;
      apply();
    });

    var form = qs('#blogSearch');
    if (form) form.addEventListener('submit', function(e){ e.preventDefault(); });

    var more = qs('#loadMore');
    if (more) more.addEventListener('click', function(){
      state.shown += 3;
      apply();
    });

    /* ⚠ On Shopify this is a REAL {% form 'customer' %} and MUST be allowed to
       POST — intercepting it would drop every signup silently.  A Shopify form
       always carries an action; the static local mirror never does, so the fake
       confirmation below is the local-only branch. */
    var sub = qs('#blogSub');
    if (sub && !sub.getAttribute('action')) sub.addEventListener('submit', function(e){
      e.preventDefault();
      sub.reset();
      var n = qs('#subNote');
      if (n) n.textContent = 'Thank you. Look out for the next issue in your inbox.';
    });
  }

  /* ---- decorative rules draw themselves in ----
         A rule starts at scaleX(0), so the observer is the ONLY thing that can
         make it appear.  Anything already on screen is therefore drawn straight
         away and never observed — an observer that is throttled (background tab)
         or unsupported can then never leave a divider invisible. */
  function drawRule(r){ r.style.animation = 'ruleIn .9s cubic-bezier(.22,.7,.25,1) both'; }

  function initRules(){
    var rules = qsa('.rule');
    if (!rules.length) return;
    if (typeof IntersectionObserver === 'undefined'){
      rules.forEach(drawRule);
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        drawRule(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    rules.forEach(function(r){
      if (r.getBoundingClientRect().top < innerHeight * 0.9) drawRule(r);
      else io.observe(r);
    });
  }

  /* ---- headings rise word by word ---- */
  function splitWords(){
    var heads = qsa('h1, section h2');
    function wrap(el){
      Array.prototype.slice.call(el.childNodes).forEach(function(n){
        if (n.nodeType === 3){
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function(p){
            if (!p) return;
            if (/^\s+$/.test(p)){ frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span');
            s.className = 'sw';
            var i = document.createElement('i');
            i.textContent = p;
            s.appendChild(i);
            frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A'){
          wrap(n);
        }
      });
    }
    heads.forEach(function(h){
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      function fire(){
        words.forEach(function(w, i){
          w.classList.add('on');
          w.firstChild.style.animationDelay = (i * 52) + 'ms';
        });
      }
      if (h.getBoundingClientRect().top < innerHeight * 0.9 ||
          typeof IntersectionObserver === 'undefined'){ fire(); return; }
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting){ fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- scroll reveals.  Anything already on screen is never hidden, so a
         failed observer can't leave the page blank (see the registration bug) ---- */
  function initReveal(){
    var els = qsa('[data-rv]');
    if (!els.length) return;
    if (typeof IntersectionObserver === 'undefined'){
      els.forEach(function(el){ el.style.opacity = '1'; });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var kind = el.getAttribute('data-rv') || 'rise';
        var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
        el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
        /* ⚠ Clearing the inline opacity is what actually makes it visible; the
           animation only decorates the arrival.  If the keyframes are ever
           missing the element still shows, instead of the page going blank. */
        el.style.opacity = '';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function(el){
      if (el.getBoundingClientRect().top > innerHeight * 0.88){
        el.style.opacity = '0';
        io.observe(el);
      }
    });
  }

  /* the search panel hands its query back through this */
  window.__twsBlogSetQuery = function(v){
    state.query = v || '';
    state.shown = PAGE_SIZE;
    apply();
  };

  function boot(){
    roots = Array.prototype.slice.call(document.querySelectorAll('.tws-blog'));
    if (!roots.length) return;
    /* how many cards show before "Load more" — a Shopify section setting,
       carried on the grid so the customizer can change it without a rebuild */
    var g = qs('#postGrid');
    var ps = g ? parseInt(g.getAttribute('data-page-size'), 10) : 0;
    if (ps > 0) { PAGE_SIZE = ps; state.shown = ps; }
    splitWords();
    initReveal();
    initRules();
    initControls();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
